import React from 'react'
import Fruits from '../Images/kpn-img-1.jpg';
import Tomato from '../Images/kpn-2.png';

export const About = () => {
  return (
    <div>
    <div className='about'>

      <div className='about-img'>
      <img src={Fruits} alt='img' />
      </div>


      <div className="about-content">
      <h4>Our Quality</h4>
      <h1>We Provide Fresh Fruits & Vegetables For Your Family</h1>
      <p>Kovai Pazhamudir Nilayam is your one stop shop for all your daily necessities. We provide the best quality of fruits & vegetables along with groceries.</p>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius provident quis minima? Repellat dicta minima deserunt, facilis ipsam amet libero ea exercitationem iure beatae qui maxime. Eligendi aliquid esse assumenda?</p>
      </div>
      <div className='tomato'>
    <img src={Tomato} alt='bannerpic' />
    </div>
    </div>

    
    </div>
  )
}
